import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { platformAPI } from '../../services/api';
import appConfig from '../../config/appConfig';
import SEO from '../../components/SEO';
import { TermsBaseline, TemplateNotice } from '../../components/legal/LegalBaseline';

// Owners/admins see the "replace this template" nudge; the public does not.
const isStaffViewer = () => {
  try {
    const role = JSON.parse(localStorage.getItem('user') || '{}').role;
    return ['owner', 'admin', 'manager'].includes(role);
  } catch { return false; }
};

const TermsAndConditions = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    platformAPI.getSettings()
      .then(res => setContent(res.data?.settings?.termsAndConditions || ''))
      .catch(err => console.error('Error loading settings:', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO title="Terms & Conditions" description={`Terms & Conditions for using ${appConfig.name}.`} path="/terms" />
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/browse" className="text-xl font-bold text-blue-600">{appConfig.name}</Link>
          <div className="flex gap-4 text-sm">
            <Link to="/support" className="text-gray-600 hover:text-blue-600">Support</Link>
            <Link to="/privacy" className="text-gray-600 hover:text-blue-600">Privacy</Link>
            <Link to="/about" className="text-gray-600 hover:text-blue-600">About</Link>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>
        {loading ? (
          <div className="text-center py-10 text-gray-500">Loading...</div>
        ) : content ? (
          <div className="bg-white rounded-xl border border-gray-200 p-8">
            <div className="prose max-w-none text-gray-700" dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        ) : (
          // No admin-authored version yet — fall back to the protective baseline.
          <div className="bg-white rounded-xl border border-gray-200 p-8">
            <TemplateNotice show={isStaffViewer()} />
            <TermsBaseline />
          </div>
        )}
      </div>

      <div className="border-t border-gray-200 bg-white mt-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-2 text-sm text-gray-500">
          <span>{appConfig.copyright}</span>
          <div className="flex gap-4">
            <Link to="/support" className="hover:text-blue-600">Support</Link>
            <Link to="/terms" className="hover:text-blue-600">Terms</Link>
            <Link to="/privacy" className="hover:text-blue-600">Privacy</Link>
            <Link to="/refund-policy" className="hover:text-blue-600">Refund Policy</Link>
            <Link to="/about" className="hover:text-blue-600">About</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
